import React, { Component } from 'react'


class RightClick extends Component {
state={
    timer: null
}

  start = () => {
    const timer = setTimeout(this.props.onLongPress , 500);
    this.setState({timer})
  }
  stop = () => {
    const timer = this.state.timer
    clearTimeout(timer)
  }


  render() {
    return (
      <div onTouchStart={this.start} onTouchEnd={this.stop}>
        {this.props.children}
      </div>
    )
  }
}

export default RightClick



// WEBPACK FOOTER //
// ./src/utils/rightClick.jsx